var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_label"},[_c('i',{staticClass:"fas fa-copy text-info",on:{"click":function($event){_vm.copyToClipboard(_vm.val)},"mouseout":_vm.out}},[_c('span',{staticClass:"tooltiptext",attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm.trans[_vm.locale].copy))])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88d6930e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Copy/CopyToClipBoard.vue
// module id = KxlF
// module chunks = 0 1 3 4 5 6 7 8 9